import React from "react";
import { getUsersBelow } from "../actions";
import { resolveErrorMessage, removeEmptyFields } from "../util";

const useFetchUsersBelow = (params) => {
  const [users, setUsers] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        setError(null);
        const cleanedParams = removeEmptyFields(params);
        const data = await getUsersBelow(cleanedParams);
        if (!data?.length) throw new Error("app.agent.dashboard.text3");
        setUsers(data);
      } catch (e) {
        const error = resolveErrorMessage(e);
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, [params]);

  return { users, loading, error };
};

export default useFetchUsersBelow;
